import { Typography, Tooltip, Stack, colors, getRecipeColor, ColorVariant } from '@ui-components/neo.tax';
import { ReactComponent as WarningTriangle } from '@ui-components/neo.tax/dist/icons/warning-triangle.svg';

interface PayrollWageNameCellProps {
  name: string;
  hasPayrollExpense: boolean;
  isPiiRedacted: boolean;
  onClick: () => void;
}

export const PayrollWageNameCell = ({
  hasPayrollExpense,
  isPiiRedacted,
  name,
  onClick,
}: PayrollWageNameCellProps): React.ReactElement => {
  const commonProps = {
    fontWeight: 'medium' as const,
    fontSize: 'inherit' as const,
    lineHeight: 'inherit' as const,
    textOverflow: 'truncate' as const,
    title: name ?? undefined,
  };
  if (hasPayrollExpense) {
    if (isPiiRedacted) {
      return (
        <Typography color="inherit" {...commonProps}>
          {name}
        </Typography>
      );
    }

    return (
      <Typography
        as="button"
        color={getRecipeColor(ColorVariant.BLUE, 'whiteBg').text}
        onClick={onClick}
        textDecoration="underline"
        {...commonProps}
      >
        {name}
      </Typography>
    );
  }
  return (
    <Stack direction="row" alignItems="center" gap={2} overflow="hidden">
      <Typography color="inherit" {...commonProps}>
        {name}
      </Typography>
      <Tooltip text="Payroll data is missing">
        <WarningTriangle width={16} color={colors.lemon[400]} />
      </Tooltip>
    </Stack>
  );
};
